/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Firestore Service (Lazy Loaded)
 *
 * - MISSION: To provide access to Firestore instance only when needed,
 * allowing the heavy SDK to be code-split and lazy-loaded.
 */

import app from './firebase';

let dbInstance = null;

/**
 * Returns a promise that resolves to the Firestore instance.
 * Dynamically imports the SDK on first call.
 */
export const getDb = async () => {
    if (dbInstance) {
        return dbInstance;
    }

    const { getFirestore } = await import('firebase/firestore');
    dbInstance = getFirestore(app);
    return dbInstance;
};

// Re-export common Firestore functions to be used dynamically
// Note: Consumers should import these dynamically too, or use the helper below.
// Actually, it's better to just let consumers import from 'firebase/firestore' directly
// inside their async functions, but we can provide a helper to ensure the SDK is loaded.

/**
 * Helper to ensure Firestore SDK is loaded before using its module.
 * Usage:
 * const { doc, getDoc } = await loadFirestoreSDK();
 */
export const loadFirestoreSDK = async () => {
    return import('firebase/firestore');
};
